<template>
  <div id="app">
    <AppHeader/>
    <main>
      <!-- Renders the active route's content -->
      <router-view />
    </main>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import './plugins/axios';
import './assets/styles.css';

export default {
  name: "App",
  components: { AppHeader },
  computed: {
  },
  methods: {
  },
  mounted() {
    this.$store.dispatch('auth/loadToken'); // Ensure token is loaded when app is initialized
  },
  async created() {
    try {
      await this.$store.dispatch('fetchProjects'); // Dispatch without namespace
      await this.$store.dispatch('getActionTypes'); // Dispatch without namespace
      await this.$store.dispatch('getInitData'); // Dispatch without namespace
      const token = new URLSearchParams(window.location.search).get('token');
      await this.$store.dispatch('initApp', token); // Centralized action
    } catch (error) {
      console.error('Error loading projects:', error);
    }
  },
};
</script>


